/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Id_LabelInputs */

const en_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID:`)
};

const fr_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID :`)
};

const de_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AUSWEIS:`)
};

const it_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID:`)
};

const ru_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИДЕНТИФИКАТОР:`)
};

const es_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDENTIFICACIÓN:`)
};

const zh_cn2_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID：`)
};

const ja_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID:`)
};

const hi_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहचान:`)
};

const pt_pt2_knp_guide_id_label = /** @type {(inputs: Knp_Guide_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU IA:`)
};

/**
* | output |
* | --- |
* | "ID:" |
*
* @param {Knp_Guide_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_id_label = /** @type {((inputs?: Knp_Guide_Id_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Id_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_id_label(inputs)
	if (locale === "de") return de_knp_guide_id_label(inputs)
	if (locale === "it") return it_knp_guide_id_label(inputs)
	if (locale === "ru") return ru_knp_guide_id_label(inputs)
	if (locale === "es") return es_knp_guide_id_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_id_label(inputs)
	if (locale === "ja") return ja_knp_guide_id_label(inputs)
	if (locale === "hi") return hi_knp_guide_id_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_id_label(inputs)
	return en_knp_guide_id_label(inputs)
});